import {useCallback, useState} from 'react';
import {Button} from '@mui/material';
import {DataFormV1} from 'schema';

type MyForm = {
  input: string;
};

export const TestScene = () => {
  const [formData, setFormData] = useState<MyForm>({
    input: '',
  });

  const handleSubmit = useCallback(() => {}, []);

  return (
    <>
      <h1>HLS Test</h1>
      <DataFormV1
        onDataChanged={setFormData}
        mode="edit"
        schema={{
          name: 'testSchema',
          parts: [
            {
              type: 'text',
              name: 'input',
              required: true,
            },
          ],
        }}
        data={formData}
        relatedData={{}}
      />
      <Button onClick={handleSubmit}>Submit</Button>
    </>
  );
};
